/** Reveal the whole section when it fits; long sections start at the viewport top. */
export function revealSongSection(element) {
  if (!element) return;
  const scrollport = element.closest('.song-view');
  if (!scrollport) {
    element.scrollIntoView?.({block: 'nearest', inline: 'nearest', behavior: 'smooth'});
    return;
  }
  const box = element.getBoundingClientRect(), view = scrollport.getBoundingClientRect();
  const viewport = window.visualViewport;
  const top = Math.max(view.top, viewport?.offsetTop || 0) + 12;
  const bottom = Math.min(view.bottom, viewport ? viewport.offsetTop + viewport.height : window.innerHeight) - 12;
  if (bottom <= top) return;
  const oversized = box.height > bottom - top;
  const delta = oversized ? box.top - top
    : box.top < top ? box.top - top : box.bottom > bottom ? box.bottom - bottom : 0;
  if (Math.abs(delta) < 1) return;
  scrollport.scrollTo({top: scrollport.scrollTop + delta, behavior: 'smooth'});
}
